import { ModerationConsole } from "@/components/skills/moderation/ModerationConsole";

export function ModerationPage() {
  return <ModerationConsole />;
}
